
/**
 * Reusable event listener for closing the dialog when the backdrop is clicked.
 * @param {Event} event click event
 * @param {HTMLElement} container container element - Can be dialog or any other container
 * @param {HTMLDialogElement} dialog dialog element
 * 
 * @example
 * const dialog = document.querySelector('dialog');
 * dialog.addEventListener('click', (event) => {
 *   closeDialogOnBackdropClick(event, this.#dom.dialog);
 * });
 */
export function closeDialogOnBackdropClick(event, container, dialog) {
  if (!container.contains(event.target)) {
    dialog.close();
  }
}